// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"423":"b0223e31","974":"0962f8dc"}[chunkId] + ".chunk.css";
};